<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            RegistrationTokenButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
        .column.large-1
          .label RT{{item.id}}
        .column.large-1
          .label Type
          .field {{item.destination_type.replace(/App\\Models\\/, '')}}
        .column.large-2
          .label Destination
          .field {{item.destination_name}}
        .column.large-5.small-12
          .label Token
          .field {{item.token}}
        .column.large-2
          .label Created
          .field {{item.created_at}}


</template>

<script>

import ModalReveal from "../structure/foundation/ModalReveal";
import Dropdown from "../structure/foundation/Dropdown";
import RegistrationTokenButtons from "../structure/ui/actions/RegistrationTokenButtons";

export default {
  name: 'RegistrationToken',
  components: {RegistrationTokenButtons, Dropdown, ModalReveal},
  props: ['item', 'type'],
  data: function () {
    return {
      strippedMessage: ''
    }
  },
  methods: {
    getStrippedMessage() {

      if (this.item.message.subject) {
        this.strippedMessage = this.item.message.subject
      } else {
        this.strippedMessage = JSON.stringify(this.item.message).slice(0, 160)
      }
      return this.strippedMessage
    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// RegistrationToken.vue?16a5b67b